"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.bentoBoxV1TotalsAbi = void 0;
exports.bentoBoxV1TotalsAbi = [
    {
        inputs: [
            {
                internalType: 'contract IERC20',
                name: '',
                type: 'address',
            },
        ],
        name: 'totals',
        outputs: [
            {
                internalType: 'uint128',
                name: 'elastic',
                type: 'uint128',
            },
            {
                internalType: 'uint128',
                name: 'base',
                type: 'uint128',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
];
//# sourceMappingURL=bentoBoxV1TotalsAbi.js.map